/* eslint-disable max-len */
export const globalSchema = [
	{
		"@context": "https://schema.org",
		"@type": "Organization",
		"@id": "https://www.storage.com/#organization",
		name: "Storage.com",
		legalName: "Storage.com",
		description:
			"Storage.com is a self-storage marketplace where you can easily browse and compare all storage facilities and units in your area. Reserve online for free with no credit card required.",
		url: "https://www.storage.com/",
		logo: {
			"@type": "ImageObject",
			url: "https://www.storage.com/images/sc-logo.svg"
		},
		address: {
			"@type": "PostalAddress",
			streetAddress: "10900 Research Blvd 160C PMB 3099",
			addressLocality: "Austin",
			addressRegion: "TX",
			postalCode: "78759",
			addressCountry: "US"
		},
		areaServed: "US",
		contactPoint: {
			"@type": "ContactPoint",
			telephone: "+1-833-448-1067",
			contactType: "customer service",
			areaServed: "US",
			availableLanguage: "English"
		},
		sameAs: [
			"https://x.com/storagecom",
			"https://www.facebook.com/SelfStorageMarketplace/",
			"https://www.linkedin.com/company/storage-com/",
			"https://www.pinterest.com/storagecom/",
			"https://www.trustpilot.com/review/storage.com"
		],
		aggregateRating: {
			"@type": "AggregateRating",
			ratingValue: "4.4",
			bestRating: "5",
			worstRating: "1",
			reviewCount: "178",
			ratingCount: "178"
		}
	},
	{
		"@context": "https://schema.org",
		"@type": "WebSite",
		"@id": "https://www.storage.com/#website",
		name: "Storage.com",
		url: "https://www.storage.com/",
		description:
			"Find and compare self-storage facilities near you. Browse thousands of units, check prices and availability, and reserve online for free -- no credit card required.",
		inLanguage: "en-US",
		publisher: {
			"@id": "https://www.storage.com/#organization"
		},
		potentialAction: {
			"@type": "SearchAction",
			target: "https://www.storage.com/search/?{search_term_string}",
			"query-input": "required name=search_term_string"
		}
	}
];

export const organizationSchema = globalSchema[0];

export const generateCLPWebPageSchema = ({
	city,
	state,
	canonicalUrl,
	title,
	description
}) => ({
	"@context": "https://schema.org",
	"@type": "WebPage",
	"@id": `${canonicalUrl}#webpage`,
	name: title,
	url: `${canonicalUrl}`,
	description,
	isPartOf: {
		"@id": "https://www.storage.com/#website"
	},
	breadcrumb: {
		"@id": `${canonicalUrl}#breadcrumb`
	},
	mainEntity: {
		"@type": "Place",
		name: `${city}, ${state}`,
		hasMap: {
			"@type": "Map",
			name: `Map of ${city}, ${state} Storage Units`,
			url: `${canonicalUrl}#map`
		}
	}
});

export const generateCLPWebsiteSchema = ({ baseUrl }) => {
	const safeBaseUrl = baseUrl || "";

	return {
		"@context": "https://schema.org",
		"@type": "WebSite",
		"@id": "https://www.storage.com/#website",
		name: "Storage.com",
		url: `${safeBaseUrl}/`,
		publisher: {
			"@id": "https://www.storage.com/#organization"
		},
		potentialAction: {
			"@type": "SearchAction",
			target: {
				"@type": "EntryPoint",
				urlTemplate: `${safeBaseUrl}/search?city={search_term_string}`,
				inLanguage: "en-US",
				actionPlatform: [
					"https://schema.org/DesktopWebPlatform",
					"https://schema.org/MobileWebPlatform"
				]
			},
			"query-input": {
				"@type": "PropertyValueSpecification",
				valueRequired: "https://schema.org/True",
				valueName: "search_term_string"
			}
		}
	};
};
